import { ReactElement, useMemo } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { never } from "client_legacy/ndaw/errors";
import { userConfiguration, ClientErrorPageConfiguration } from "client_legacy/ndaw/workspaceAbilitiesStatusProvider";
import { Forbidden } from "./ErrorCodes/Forbidden";
import { InternalServerError } from "./ErrorCodes/InternalServerError";
import { NotFound } from "./ErrorCodes/NotFound";
import styles from "./ErrorPage.module.less";
import { setTrackingId } from "client/Misc/utils";

export type ErrorPageProps = {
	httpCode: 403 | 404 | 500;
};

export const ErrorPage = (props: ErrorPageProps): ReactElement => {
	const {
		httpCode
	} = props;

	const configuration: ClientErrorPageConfiguration = useMemo(
		() => {
			return userConfiguration().errorPages;
		},
		[]
	);

	const renderErrorCodeSection = (): ReactElement => {
		switch (httpCode) {
			case 403:
				return <Forbidden />;
			case 404:
				return (
					<NotFound
						customHtml={configuration.errorPageHtml}
						supportTelephoneNumber={configuration.supportTelephoneNumber}
						supportEmailAddress={configuration.supportEmailAddress}
					/>
				);
			case 500:
				return (
					<InternalServerError
						customHtml={configuration.errorPageHtml}
						supportTelephoneNumber={configuration.supportTelephoneNumber}
						supportEmailAddress={configuration.supportEmailAddress}
					/>
				);
			default:
				never(httpCode);
		}
	};

	return (
		<div
			{...setTrackingId("error-page")}
			className={styles.root}
		>
			<h1>{localize("_SomethingWentWrong")}</h1>
			{renderErrorCodeSection()}
		</div>
	);
};
ErrorPage.displayName = "ErrorPage";
